import { render, staticRenderFns } from "./BindingWizard.vue?vue&type=template&id=10f73fd6&scoped=true&lang=pug&"
import script from "./BindingWizard.vue?vue&type=script&lang=ts&"
export * from "./BindingWizard.vue?vue&type=script&lang=ts&"
import style0 from "./BindingWizard.vue?vue&type=style&index=0&id=10f73fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f73fd6",
  null
  
)

export default component.exports